import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap"; // Import React-Bootstrap
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";

const statuses = [
  { label: "Salarié", value: "Salarie" },
  { label: "Entrepreneur", value: "Entrepreneur" },
  { label: "Demandeur d'emploi", value: "Demandeur_emploi" },
  { label: "Étudiant", value: "Etudiant" },
];

function OwnerStatus() {
  const navigate = useNavigate();
  const currentStep = "Propriétaire";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();

  const handleStatusSelect = async (status) => {
    await dispatch(
      addToCart({
        status: status,
      })
    );
    navigate("/business-country");
  };

  const handleSkip = () => {
    navigate("/business-country");
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        paddingBottom: "40px",
        position: "relative",
      }}
    >
      <Header />

      <ProgressBar steps={steps} currentStep={currentStep} />

      <Container className="mt-4 text-center">
        <h4 className="text-2xl font-semibold">Vous êtes actuellement ?…</h4>
      </Container>

      <Container className="mt-4 d-flex justify-content-center">
        <Row className="w-100" style={{ maxWidth: "500px" }}>
          {statuses.map((status, index) => (
            <Col
              xs={12}
              md={6}
              className="mb-4 d-flex justify-content-center"
              key={index}
            >
              <div
                className="status-box d-flex align-items-center justify-content-center"
                onClick={() => handleStatusSelect(status.value)}
                style={{
                  border: "2px solid #ddd",
                  borderRadius: "8px",
                  padding: "10px",
                  cursor: "pointer",
                  height: "80px",
                  width: "80%",
                  maxWidth: "250px",
                  transition: "border-color 0.3s",
                  textAlign: "center",
                  color: "#000",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#FF5500")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "#ddd")
                }
              >
                <span style={{ fontSize: "0.9rem" }}>{status.label}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <Container className="text-center mt-3">
        <span
          onClick={handleSkip}
          style={{ color: "#3392FF", cursor: "pointer" }}
        >
          Je ne souhaite pas répondre
        </span>
      </Container>
    </div>
  );
}

export default OwnerStatus;
